import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
/**
 * @internal
 */
export const calendarClassNames = {
  root: 'fui-Calendar',
  divider: 'fui-Calendar__divider',
  goTodayButton: 'fui-Calendar__goTodayButton',
  monthPickerWrapper: 'fui-Calendar__monthPickerWrapper',
  liveRegion: 'fui-Calendar__liveRegion'
};
const useRootStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw",
    a9b677: "f13dwy2t"
  },
  normalize: {
    E5pizo: "f1couhl3",
    B7ck84d: "f1ewtqcl",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1s184ao",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai"
  },
  monthPickerNotVisible: {
    Beiy3e4: "f1vx9l62"
  },
  dayAndMonthPickersVisible: {
    a9b677: "fcy5b15"
  },
  dayPickerVisibleAndWeekNumbersShown: {
    a9b677: "fhsg0in"
  },
  dayAndMonthPickersVisibleAndWeekNumbersShown: {
    a9b677: "fcarq7f"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f13dwy2t{width:220px;}", ".f1couhl3{box-shadow:none;}", ".f1ewtqcl{box-sizing:border-box;}", [".f1s184ao{margin:0;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".f1vx9l62{flex-direction:column;}", ".fcy5b15{width:440px;}", ".fhsg0in{width:250px;}", ".fcarq7f{width:470px;}"]
});
const useDividerStyles = /*#__PURE__*/__styles({
  base: {
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    u1mtju: ["fe2nn5g", "f1rcbay7"],
    Bhzewxz: "f15twtuk"
  }
}, {
  d: [[".fe2nn5g{border-right:1px solid var(--colorNeutralStroke2);}", {
    p: -1
  }], [".f1rcbay7{border-left:1px solid var(--colorNeutralStroke2);}", {
    p: -1
  }], ".f15twtuk{top:0;}"]
});
const useMonthPickerWrapperStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}"]
});
const useGoTodayButtonStyles = /*#__PURE__*/__styles({
  base: {
    qb2dma: "fpydfdc",
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    B5kzvoi: "f1yab3r1",
    B7ck84d: "f1e4lqlz",
    sj55zd: "f19n0e5",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fy9rknc",
    Bqenvij: "f1tvdnth",
    Bg96gwp: "fpfng1i",
    t21cq0: ["f17vyym1", "fb5scp"],
    B6of3ja: "f4gg0ds",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1gl81tg",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1p2x7z2",
    seuwu7: "fvy6vk6",
    Jwef8y: "f9ql6rf",
    Bi91k9c: "f1f1pb61",
    eoavqd: "f8491dx",
    Bx7pl5v: 0,
    Bnosqey: 0,
    Bv57zgv: 0,
    Bbxjs3m: "fzk52v6",
    knvgbf: 0,
    B23s7e0: 0,
    Be8uuq8: 0,
    B3ons6i: 0,
    Bnj8mme: "fxh1mxx",
    B2d53fq: "fc9d3oc",
    Dyrjrp: "f1cqwcg4",
    Be90el1: "fmjaa5u"
  }
}, {
  d: [".fpydfdc{align-self:flex-end;}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", ".f1yab3r1{bottom:0;}", ".f1e4lqlz{box-sizing:content-box;}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".f1mo0ibp{font-family:inherit;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".f1tvdnth{height:30px;}", ".fpfng1i{line-height:30px;}", ".f17vyym1{margin-right:16px;}", ".fb5scp{margin-left:16px;}", ".f4gg0ds{margin-top:3px;}", [".f1gl81tg{overflow:visible;}", {
    p: -1
  }], [".f1p2x7z2{padding:0 4px;}", {
    p: -1
  }], ".fvy6vk6 div{font-size:var(--fontSizeBase200);}", ".f1cqwcg4:disabled{color:var(--colorNeutralForegroundDisabled);}", ".fmjaa5u:disabled{pointer-events:none;}"],
  h: [".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}", ".f1f1pb61:hover{color:var(--colorBrandForeground1);}", ".f8491dx:hover{cursor:pointer;}", ".fc9d3oc:hover:active{color:var(--colorBrandForeground2);}"],
  m: [["@media (forced-colors: active){.fzk52v6:hover{outline:var(--strokeWidthThin);}}", {
    p: -1,
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fxh1mxx:hover{border-radius:var(--borderRadiusSmall);}}", {
    p: -1,
    m: "(forced-colors: active)"
  }]]
});
const useLiveRegionStyles = /*#__PURE__*/__styles({
  base: {
    Bgfg5da: 0,
    B9xav0g: 0,
    oivjwe: 0,
    Bn0qgzm: 0,
    B4g9neb: 0,
    zhjwy3: 0,
    wvpqe5: 0,
    ibv6hh: 0,
    u1mtju: 0,
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    i8vvqc: 0,
    g2u3we: 0,
    icvyot: 0,
    B4j52fo: 0,
    irswps: "f3bhgqh",
    Bqenvij: "f1mpe4l3",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1jlpb2r",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai",
    qhf8xq: "f1euv43f",
    a9b677: "frkrog8"
  }
}, {
  d: [[".f3bhgqh{border:none;}", {
    p: -2
  }], ".f1mpe4l3{height:1px;}", [".f1jlpb2r{margin:-1px;}", {
    p: -1
  }], [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".f1euv43f{position:absolute;}", ".frkrog8{width:1px;}"]
});
/**
 * @internal
 *
 * Apply styling to the Calendar slots based on the state
 */
export const useCalendarStyles_unstable = props => {
  'use no memo';

  const rootStyles = useRootStyles();
  const dividerStyles = useDividerStyles();
  const monthPickerWrapperStyles = useMonthPickerWrapperStyles();
  const goTodayButtonStyles = useGoTodayButtonStyles();
  const liveRegionStyles = useLiveRegionStyles();
  const {
    className,
    isDayPickerVisible,
    isMonthPickerVisible,
    showWeekNumbers
  } = props;
  return {
    root: mergeClasses(calendarClassNames.root, rootStyles.base, rootStyles.normalize, !isMonthPickerVisible && rootStyles.monthPickerNotVisible, isDayPickerVisible && isMonthPickerVisible && !showWeekNumbers && rootStyles.dayAndMonthPickersVisible, isDayPickerVisible && !isMonthPickerVisible && showWeekNumbers && rootStyles.dayPickerVisibleAndWeekNumbersShown, isDayPickerVisible && isMonthPickerVisible && showWeekNumbers && rootStyles.dayAndMonthPickersVisibleAndWeekNumbersShown, className),
    divider: mergeClasses(calendarClassNames.divider, dividerStyles.base),
    monthPickerWrapper: mergeClasses(calendarClassNames.monthPickerWrapper, monthPickerWrapperStyles.base),
    goTodayButton: mergeClasses(calendarClassNames.goTodayButton, goTodayButtonStyles.base),
    liveRegion: mergeClasses(calendarClassNames.liveRegion, liveRegionStyles.base)
  };
};